import {AdminUserType} from './BosTools/AdminUserType';

export enum BosToolsRole {
  Undetermined,
  Admin,
}

export class UndeterminedBosToolsUserType {
  public readonly key = 'UndeterminedBosToolsUserType';
  public readonly bosToolsRole = BosToolsRole.Undetermined;
}

export class InvalidBosToolsUserType {
  public readonly key = 'InvalidBosToolsUserType';
  public readonly value = new UndeterminedBosToolsUserType();
}

export class ValidBosToolsUserType {
  public readonly key = 'ValidBosToolsUserType';

  constructor(public readonly value: AdminUserType) {}
}

export type BosToolsUserType = ValidBosToolsUserType | InvalidBosToolsUserType | UndeterminedBosToolsUserType;

type BosToolsUserTypeOptions<TReturn> = {
  Admin: (adminUserType: AdminUserType) => TReturn;
  Undetermined: () => TReturn;
};

export const matchBosToolsUserType = <TReturn>(
  bosToolsUserType: ValidBosToolsUserType['value'] | InvalidBosToolsUserType['value'],
  options: BosToolsUserTypeOptions<TReturn>
): TReturn => {
  switch (bosToolsUserType.key) {
    case 'UndeterminedBosToolsUserType':
      return options.Undetermined();
    case 'AdminUserType':
      return options.Admin(bosToolsUserType);
  }
};
